import { MenuItem } from '../models/menu/menu.model';

export const pilotMenu: MenuItem[] = [];
